const DEFAUL_CURRENCY = 'EUR';
const SWIZZ_CURRENCY = 'CHf';

export { DEFAUL_CURRENCY, SWIZZ_CURRENCY };
